import React from "react";
import { ISerializedUIField, IWDDesignModeProps, PropertyPath, getEditorFields } from "./common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateSerializedField, renderField } from "./dnd";
import './StaticFieldsList.scss';
import { IContextProvider } from "../../uxp";
import { useAlert } from "uxp/components";
import { hasValue } from "../../util";

interface IStaticFieldsListProps {
    types: string[],
    designer: IWDDesignModeProps,
    uxpContext: IContextProvider,
    uiProps: any,
    fields: ISerializedUIField[],
    containerId: string,
    onChangeLabels: (newLabels: ISerializedUIField[]) => void,
    contextData: any
    propPath: PropertyPath
}

export const StaticFieldsList: React.FunctionComponent<IStaticFieldsListProps> = (props) => {
    const { fields, containerId, onChangeLabels, contextData, designer, uxpContext, uiProps, types, propPath } = props
    const labels = fields.filter(f => f.droppableContainerId == containerId)

    const alerts = useAlert()
    const registeredFileds = getEditorFields();

    function onRemove(f: ISerializedUIField) {
        const _fields = fields.filter(field => field.id !== f.id)
        onChangeLabels(_fields)
    }

    async function addNewField() {
        let selectedType = null
        if (types.length == 0) return
        if (types.length == 1) {
            selectedType = types[0]
        }
        else if (types.length > 1) {
            const data = await alerts.form({
                title: 'Select Field type to add',
                formStructure: [
                    {
                        name: 'type',
                        label: 'Field type',
                        type: 'select',
                        options: Object.values(registeredFileds).filter(f => types.includes(f.id)).map(f => ({ label: f.description, value: f.id })),
                        validate: {
                            required: true
                        }
                    }
                ]
            })

            if (!hasValue(data?.type)) return
            selectedType = data.type
        }

        if (!hasValue(selectedType)) return
        const newLabel = generateSerializedField(selectedType)
        newLabel.droppableContainerId = containerId
        const _fields = [...fields]
        _fields.push(newLabel)
        onChangeLabels(_fields)
    }

    return <div className="uxp-label-list-component-container" onClick={e => {e.preventDefault(); e.stopPropagation()}}>
        {labels.map((label: ISerializedUIField, i: number) => {
            const globalIndex = fields.findIndex(f => f.id == label.id)

            return <div className="uxp-label-list-label-container">
                {renderField(label, propPath, globalIndex, designer, uxpContext, contextData, uiProps, onRemove)}
            </div>
        })}

        {(designer && (designer.mode != 'thumbnail' && designer.mode != 'live')) &&
            <div className="uxp-label-list-add"
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    addNewField()
                }}
            >
                <FontAwesomeIcon icon={['fas', 'plus']} />
            </div>
        }
    </div>
}

